<!-- @format -->

<template>
	<div class="check-content">
		<el-input v-model="filterValue" size="small" placeholder="请输入关键字查询" />

		<el-collapse v-if="checkGroupList[0]?.children" v-model="activeCollapse">
			<el-collapse-item v-for="item in checkGroupList" :key="item.code" :title="item.label" :name="item.code">
				<el-checkbox-group v-model="checkList" class="checkbox-group-list" @change="(e) => emit('change', e)">
					<el-checkbox
						v-for="itm in item.children"
						:key="itm.code"
						:label="itm.code"
						class="checkbox-group-item"
						size="large"
					>
						<slot :item="itm"> {{ itm.label }}</slot>
					</el-checkbox>
				</el-checkbox-group>
			</el-collapse-item>
		</el-collapse>
		<el-checkbox-group v-else v-model="checkList" class="checkbox-group-list" @change="(e) => emit('change', e)">
			<el-checkbox
				v-for="item in checkGroupList"
				:key="item.code"
				:label="item.code"
				class="checkbox-group-item"
				size="large"
			>
				<slot :item="item"> {{ item.label }}</slot>
			</el-checkbox>
		</el-checkbox-group>
	</div>
</template>

<script setup lang="ts">
	interface CheckGroupList {
		code: string;
		label: string;
		[key: string]: any;
	}
	[];

	interface Props {
		checkGroupList: CheckGroupList; // checkboxList
		modelValue: any[]; // 绑定选中的值
	}

	const props = withDefaults(defineProps<Props>(), {});

	const emit = defineEmits(['update:modelValue', 'change']);

	const filterValue = ref<string>('');

	const activeCollapse = ref<string[]>(props.checkGroupList.map((i) => i.code));

	const flatCheckGroupList = computed(() =>
		props.checkGroupList.reduce((arr, itm) => (itm.children ? [...arr, ...itm.children] : [...arr, itm]), []),
	);

	const checkGroupList = computed(() => {
		const filterList = (list) => list?.filter((itm) => itm.label.includes(filterValue.value)) || [];
		return props.checkGroupList[0]?.children
			? props.checkGroupList.reduce((arr, item) => {
					const children = filterList(item.children);
					if (children.length) {
						return [...arr, { ...item, children }];
					} else {
						return arr;
					}
			  }, [])
			: filterList(props.checkGroupList);
	});

	const checkList = computed({
		get() {
			return props.modelValue.map((itm) => itm.code || itm);
		},
		set(val) {
			const list = val.map((itm) => getItem(flatCheckGroupList.value, itm));
			emit('update:modelValue', list);
		},
	});

	const getItem = (
		list: {
			code: string;
			[key: string]: any;
		}[],
		code: string,
	) =>
		list
			.reduce((arr, itm) => (itm.children ? [...arr, ...itm.children] : [...arr, itm]), [])
			.find((item) => item.code === code);
</script>

<style lang="scss">
	.check-content {
		height: 100%;
		overflow: auto;

		.el-input {
			padding-top: 10px;
		}
	}

	.checkbox-group-list {
		display: flex;
		flex-wrap: wrap;
		padding-top: 10px;

		.checkbox-group-item {
			flex: 50%;
			text-align: center;
			margin: 0;
		}
	}
</style>
